import Language from "orbiter-core/src/datastructures/languages/Language";
import MultiLanguageString from "orbiter-core/src/datastructures/languages/MultiLanguageString";
import SingleLanguageString from "orbiter-core/src/datastructures/languages/SingleLanguageString";
import ApiController from "../ApiController";
import {
    IHandrailPoleFinish,
    default as HandrailPoleFinish
} from "../../../../../shared/datastructures/staircasedata/HandrailPoleFinish";

// TODO: too much code duplication
export default class HandrailPoleFinishAPI extends ApiController<HandrailPoleFinish> implements IHandrailPoleFinish {

    public static getBaseEndpoint(): string{
        return "hotec/handrailpolefinish";
    }

    public static getApiKey(): string{
        return "handrailPoleFinish";
    }

    public static getPluralApiKey(): string{
        return "handrailPoleFinishes";
    }

    public async parseFromDictionary(dictionary): Promise<void> {

        const title = new MultiLanguageString(
            dictionary.title.map((x) => {
                // TODO: LanguageAPI?
                const l = new Language(
                    x.languageId,
                    null,
                    null,
                );
                return new SingleLanguageString(
                    l,
                    x.value,
                );
            }),
        );

        const desc = new MultiLanguageString(
            dictionary.description.map((x) => {
                // TODO: LanguageAPI?
                const l = new Language(
                    x.languageId,
                    null,
                    null,
                );
                return new SingleLanguageString(
                    l,
                    x.value,
                );
            }),
        );

        const handrailPoleFinish = new HandrailPoleFinish(
            title,
            desc,
            dictionary.price,
            dictionary.imagePreviewIds,
        );
        this.setData(handrailPoleFinish);
    }

    public getDescription(): MultiLanguageString {
        return this.getData().getDescription();
    }

    public getPrice(): number {
        return this.getData().getPrice();
    }

    public async setPrice(price: number): Promise<void> {
        this.getData().setPrice(price);
        await this.updateProperty("price", price);
    }

    public async setDescription(newDescription: MultiLanguageString): Promise<void> {
        this.getData().setDescription(newDescription);
        await this.updateProperty("description", newDescription);
    }

    public async setTitle(newTitle: MultiLanguageString): Promise<void> {
        this.getData().setTitle(newTitle);
        await this.updateProperty("title", newTitle);
    }

    public getTitle(): MultiLanguageString {
        return this.getData().getTitle();
    }

    public getImagePreviewIds(): string[] {
        return this.getData().getImagePreviewIds();
    }

    public async setImagePreviewIds(newImagePreviewIds: string[]): Promise<void> {
        this.getData().setImagePreviewIds(newImagePreviewIds);
        await this.updateProperty("imagePreviewIds", newImagePreviewIds);
    }

}
